import axios from 'axios';

const markAsUnread = async (token, contactId) => {

    var data = {
      "unread": 0,
      "token": token
    };
    
    const headers = { 
        'Content-Type': 'application/json',
    };

    // console.log(data);
    try {
        await axios.put(process.env.REACT_APP_BACKEND_HOST+'/api/v1/contact/'+contactId, data, { headers })
    }catch(err) {
        console.log(err);
        return false
    }
};

export default markAsUnread